import { LocationQuery } from 'vue-router';
import { http } from '@/core/helpers/axiosHelper';

export class CommuterTrafficFeeService {
   async getCommuterTrafficFees(query: LocationQuery) {
      return await http.get(`/calculate-commuter-traffic-fees`, { params: { ...query } }).then((response) => response.data);
   }
}
